// extracted by mini-css-extract-plugin
module.exports = {"mutation":"AddressMutation_mutation__1gW-J","highlighted":"AddressMutation_highlighted__ls9nQ"};